export async function fetchListenerQuestion(
  episodeId: string
): Promise<ListenerQuestionResponse | null> {
  try {
    const response = await fetch(
      `/api/proxy/v3/episodes/webEpisodeId:${episodeId}/question`
    );
    // "404" for Q&A questions
    if (response.status === 204) {
      return null;
    }
    if (response.ok) {
      return response.json();
    }
    throw new Error('Response not ok');
  } catch (e) {
    console.warn('Error fetching from Interactivity API: ', e);
    throw new Error(e);
  }
}

export type ListenerQuestionResponse = {
  episodeId: number;
  questionId: number;
  text: string;
  created: Date;
  replyCount: number;
  hasNewReplies: boolean;
  openingDate: Date;
  closingDate: Date;
  creationEpochTime: number;
  stationId: number;
};
